/**
 * Which chart the data panel describes — pure, so the rule is tested here
 * rather than only in the one place this app cannot test (`App`).
 *
 * The panel is pointed at a chart by a gesture (the data key, a command), and
 * that pointing is view state: it is not saved, and it survives a layout switch
 * while the chart it names does not. Two forms of the panel are *kept* rather
 * than peeked, and a kept panel always describes something on screen:
 *
 * - **Docked**, it follows the active chart until somebody points it — the dock
 *   is saved and the pointing is not, so after a reload nobody has.
 * - **Detached**, it follows the layout you switch to (owner, 2026-10-28,
 *   docs/plans/desktop-electron.md rule 4): the window is reused, and shows the
 *   new layout's active chart. It used to keep the old layout's chart id, find
 *   no such chart, and close — reopening on the next hover of the data key.
 *
 * `null` is an answer: a kept panel on a layout with no chart says so.
 */
export function dataPanelTarget({
  pointed,
  chartIds,
  activeChartId,
  docked,
  detached,
}: {
  /** The chart a gesture last pointed the panel at, in any layout. */
  pointed: string | null;
  /** The charts in the layout on screen. */
  chartIds: readonly string[];
  activeChartId: string | undefined;
  docked: boolean;
  detached: boolean;
}): string | null {
  if (pointed !== null && chartIds.includes(pointed)) return pointed;
  if (docked || detached) return activeChartId ?? null;
  return null;
}
